import { render, staticRenderFns } from "./QuestionBankCon.vue?vue&type=template&id=1c8a743c&scoped=true&"
import script from "./QuestionBankCon.vue?vue&type=script&lang=js&"
export * from "./QuestionBankCon.vue?vue&type=script&lang=js&"
import style0 from "./QuestionBankCon.vue?vue&type=style&index=0&id=1c8a743c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8a743c",
  null
  
)

export default component.exports